import axios from "axios";

import Cookies from 'js-cookie'
export function encode(obj){
  return Object.keys(obj).map(function(key) {
    return key + '=' + obj[key];
  }).join('&');
}

export const API_URL=process.env.REACT_APP_API_URL+"/api";


export default function client(){
  let cookie=Cookies.get('stories_session')
  let headers=Object.assign({
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  }, cookie ? {"Authorization": "Bearer "+cookie} : {})
  return axios.create({
    baseURL: API_URL,
    timeout: 10000,
    headers
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js